// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1GU1S","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2PeX6"};